<script setup lang="ts">
import { Skyjo } from "@/skyjo/game";
import { Player } from "@/skyjo/game";
import { axios, socket } from "@/lib/axios";


const games = ref([] as Skyjo[])
const inputPseudo = ref("");
const storagePseudo = ref(localStorage.getItem("pseudo") || "");
const canDisconnect = ref(true)
onMounted(() => {
    const params = new URLSearchParams(window.location.search)
    const name = params.get('name')
    if (name) {
        changeName(name)
        canDisconnect.value = false
    }
    socket.on("lobby", () => { loadListOfGame(); });
    socket.emit("joinRoom", "lobby", storagePseudo.value);
    loadListOfGame();
})

async function createGame() {
    if (!storagePseudo.value) return;
    const skyjo = new Skyjo();

    try {
        const res = await axios.post("/api/skyjo")
        skyjo.id = res.data.id;
    } catch (error) {
        console.error('Failed to load games:', error);
    }

    await joinTheGame(skyjo)
}

async function joinTheGame(skyjo: Skyjo) {
    if (!skyjo.isGameRound('start')) return

    if (!skyjo.players.joinTheGame(storagePseudo.value)) return
    try {
        await skyjo.save()
        window.location.href = route("skyjo", [skyjo.id]);
    } catch (error) {
        console.error('Failed to load games:', error);
    }
}

async function loadListOfGame() {
    try {
        const res = await axios.get(`/api/skyjo/getall?refresh=${new Date().getTime()}`);
        games.value = res.data.map((game: { game: Skyjo }) => new Skyjo(game.game, storagePseudo.value));
    } catch (error) {
        console.error('Failed to load games:', error);
    }
}

function changeName(pseudo: string) {
    storagePseudo.value = pseudo = pseudo.trim();
    localStorage.setItem("pseudo", pseudo);
}

function gamePlayersNames(game: Skyjo) {
    return game.players.map((p: Player) => p.pseudo).join(" - ");
}

function gameStatus(game: Skyjo): string {
    if (game.isGameRound("start")) return "Wait for players";
    if (game.isGameRound("end")) return "Ended";
    return "In progress";
}
</script>

<template>
    <div class="flex flex-col sm:w-3/4 lg:w-2/3 skyjo-text mx-auto px-3 text-gray-700 dark:text-gray-200">
        <div class="flex flex-col sm:flex-row justify-between items-center">
            <div class="underline underline-offset-8 p-4 my-3" v-if="storagePseudo">Bienvenue {{ storagePseudo }} !</div>
            <SkyjoButton @click="changeName('')" v-if="storagePseudo && canDisconnect">Disconnect</SkyjoButton>
            <input class="shadow appearance-none skyjo-text w-3/4 sm:w-2/3 border-2 !border-gray-700 rounded-lg p-4 my-3 leading-tight focus:outline-none focus:shadow-none focus:ring-0 focus:ring-gray-700" type="text" placeholder="Name" v-model="inputPseudo" v-if="!storagePseudo" />
            <SkyjoButton @click="changeName(inputPseudo)" v-if="!storagePseudo">connect</SkyjoButton>
        </div>
        <template v-if="storagePseudo">
            <div class="flex items-center justify-between border-2 rounded my-3 p-3 mb-6">
                <img src="/images/logo.png" class="w-1/5" />
                <SkyjoButton @click="createGame()">Create</SkyjoButton>
            </div>
            <div v-for="(skyjo, index) in games" :key="index" class="border rounded text-center p-3 my-3">
                <div class="flex justify-between items-start">
                    <div class="skyjo-text-xl">Room {{ skyjo.id }}</div>
                    <div class="flex justify-end gap-2">
                        <SkyjoButton @click.prevent="joinTheGame(skyjo)" v-if="skyjo.canJoinTheGame">Join</SkyjoButton>
                        <SkyjoButton :href="route('skyjo', [skyjo.id])" v-if="skyjo.players.me">Play</SkyjoButton>
                        <SkyjoButton :href="route('skyjo', [skyjo.id])" v-if="!skyjo.players.me">Look</SkyjoButton>
                    </div>
                </div>
                <div class="skyjo-text-xs">
                    {{ gamePlayersNames(skyjo) }}<br />
                    {{ gameStatus(skyjo) }}
                </div>
            </div>
        </template>
    </div>
</template>

<style scoped></style>
